import React, { useState } from 'react';
import { Container, Card, Button, Nav } from 'react-bootstrap';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../utils/AuthContext';
import { authAPI } from '../services/api';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [activeTab, setActiveTab] = useState('google');

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const response = await authAPI.googleAuth(credentialResponse.credential);
      const { access_token, user } = response.data;

      login(access_token, user);
      toast.success('Login successful!');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.status === 401) {
        toast.error('Only @wishfin.com users can log in');
      } else {
        toast.error('Login failed. Please try again.');
      }
    }
  };

  const handleGoogleError = () => {
    toast.error('Google login failed');
  };

  return (
    <div className="login-page" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      background: '#f5f5f5'
    }}>
      <Container>
        <div className="d-flex justify-content-center">
          <Card style={{ maxWidth: '480px', width: '100%', borderRadius: '12px' }} className="shadow">
            <Card.Body className="p-5">
              <div className="text-center mb-4">
                <img
                  src="https://www.wishfin.com/images/home-page/wishfin-logo.svg"
                  alt="Wishfin HRMS"
                  height="50"
                  className="mb-3"
                />
                <h2 className="fw-bold mb-4" style={{ color: '#5b6cf2' }}>Wishfin BugTracker</h2>
              </div>

              <Nav variant="tabs" className="mb-4" style={{ borderBottom: '2px solid #e0e0e0' }}>
                <Nav.Item>
                  <Nav.Link
                    active={activeTab === 'google'}
                    onClick={() => setActiveTab('google')}
                    style={{
                      color: activeTab === 'google' ? '#000' : '#666',
                      fontWeight: activeTab === 'google' ? '600' : '400',
                      borderBottom: activeTab === 'google' ? '3px solid #5b6cf2' : 'none',
                      background: 'transparent'
                    }}
                  >
                    Google
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <div className="text-center mb-4">
                <p className="text-muted">Sign in with your company Google account</p>
              </div>

              <div style={{ position: 'relative' }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  opacity: 0,
                  cursor: 'pointer',
                  zIndex: 2
                }}>
                  <GoogleLogin
                    onSuccess={handleGoogleSuccess}
                    onError={handleGoogleError}
                    width="100%"
                  />
                </div>
                <Button
                  className="w-100 py-3 fw-semibold position-relative"
                  style={{
                    background: '#5b6cf2',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    pointerEvents: 'none',
                    zIndex: 1
                  }}
                >
                  <svg className="me-2" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
                    <path d="M9.003 18c2.43 0 4.467-.806 5.956-2.184L12.05 13.56c-.806.54-1.836.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H.96v2.332C2.44 15.983 5.485 18 9.003 18z" fill="#34A853"/>
                    <path d="M3.964 10.712c-.18-.54-.282-1.117-.282-1.71 0-.593.102-1.17.282-1.71V4.96H.957C.347 6.175 0 7.55 0 9.002c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
                    <path d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.428 0 9.002 0 5.485 0 2.44 2.017.96 4.958L3.967 7.29c.708-2.127 2.692-3.71 5.036-3.71z" fill="#EA4335"/>
                  </svg>
                  Sign in with Google
                </Button>
              </div>

              <div className="mt-4 text-center">
                <small className="text-muted">
                  By signing in, you agree to our terms and privacy policy
                </small>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
}

export default Login;
